import api from '@/api';
import { QuestCustomerWithoutMovementRequest } from './CustomerWithoutMovement.types';
import { API_BASE_URL } from '../../index';

const CONTROLLER_URL = `${API_BASE_URL}/Reports`;

export async function getQuestReportCustomerWithoutMovement(
  params: QuestCustomerWithoutMovementRequest,
) {
  const result = (await api.getReport(
    `${CONTROLLER_URL}/CustomerWithoutMovement`,
    params,
  )) as unknown;

  return result as BlobPart;
}
